// Renders an otpauth:// URI as a scannable QR code image for authenticator-app setup.
// Shared by the first-time MFA setup (Login) and the re-register flow (Settings).

import { useEffect, useState } from "react";
import QRCode from "qrcode";

export function TotpQrCode({ uri }: { uri: string }) {
  const [dataUrl, setDataUrl] = useState<string | null>(null);

  useEffect(() => {
    let active = true;
    QRCode.toDataURL(uri, { width: 192, margin: 1 })
      .then((url) => {
        if (active) setDataUrl(url);
      })
      .catch(() => {
        // A failed QR render is non-fatal; the manual setup key is still shown.
        if (active) setDataUrl(null);
      });
    return () => {
      active = false;
    };
  }, [uri]);

  if (!dataUrl) return null;
  return (
    <div className="flex justify-center">
      <img
        src={dataUrl}
        alt="QR code to add this account to an authenticator app"
        width={192}
        height={192}
        className="rounded-md bg-white p-2"
      />
    </div>
  );
}
